import { useRef, useState } from 'react'
import { Box, Button } from '@material-ui/core'
import { useTheme } from '@material-ui/styles'
import { useHistory } from 'react-router-dom'

import {
  BackButton,
  Card,
  Container,
  ContentHeader,
  LoadingFeedback,
  Page,
} from 'components'
import { RegulationForm, RegulationVersionForm } from './components'

import helpers from 'helpers'

import { useSnackbar } from 'hooks'

import * as service from 'service'
import { routes } from 'Routes'

const RegulationsNew = () => {
  const [loading, setLoading] = useState(false)

  const theme = useTheme()
  const history = useHistory()
  const snackbar = useSnackbar()

  const generalRef = useRef()
  const versionRef = useRef()

  const handleRedirect = () => history.push(routes.regulations.all)

  const handleSubmit = async () => {
    const [generalData, versionData] = await Promise.all([
      generalRef.current.submit(),
      versionRef.current.submit(),
    ])

    if (!generalData || !versionData) return

    setLoading(true)

    try {
      const response = await service.backoffice.regulations.create(generalData)

      await service.backoffice.regulationVersions.create({
        regulationId: response?.data?.regulation?.id,
        ...versionData,
        startsAt: versionData.startsAt?.toISOString(),
        endsAt: versionData.endsAt?.toISOString() || null,
      })

      snackbar.open({
        message: 'Regulamento criado com sucesso!',
        variant: 'success',
      })

      handleRedirect()
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(
            error?.response?.data?.error,
            false,
          ) || 'Falha ao criar regulamento!',
        variant: 'error',
      })
      setLoading(false)
    }
  }

  return (
    <Page title="Novo regulamento">
      <LoadingFeedback open={loading} />
      <Container
        maxWidth={false}
        spacingXl={30}
        spacingLg={25}
        spacingMd={10}
        spacingSm={10}
      >
        <ContentHeader
          title="Novo"
          menu="Documentos"
          subtitle="Criar regulamento"
        />
        <Box display="flex" flexDirection="column" gridGap={theme.spacing(4)}>
          <RegulationForm ref={generalRef} />
          <Card title="Informações da versão" paddingCard={0}>
            <RegulationVersionForm ref={versionRef} />
          </Card>
          <Box display="flex" gridGap={theme.spacing(1)}>
            <BackButton onClick={handleRedirect}>Voltar</BackButton>
            <Button variant="contained" color="primary" onClick={handleSubmit}>
              Salvar
            </Button>
          </Box>
        </Box>
      </Container>
    </Page>
  )
}

export default RegulationsNew
